import { render } from "./ContactUpdate.vue?vue&type=template&id=eda3772e&scoped=true"
import script from "./ContactUpdate.vue?vue&type=script&lang=js"
export * from "./ContactUpdate.vue?vue&type=script&lang=js"

import "./ContactUpdate.vue?vue&type=style&index=0&id=eda3772e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eda3772e"]])

export default __exports__